import {
  Breakpoints,
  styled,
  TextTag,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import {Header} from '../../types/header';
import {Text} from '@volkswagen-onehub/components-core';

interface HeaderInterface {
  title: Header['title'];
  descriptions?: Header['descriptions'];
  image: Header['image'];
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #eae5dd;
  margin-bottom: ${(props) => props.theme.size.dynamic0150};
  justify-content: center;

  @media screen and (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
  }
`;

const ImageHeaderContainer = styled.div`
  flex: 1.1;
  align-self: center;

  img {
    width: 100%;
  }
`;

const TitleHeaderContainer = styled.div`
  flex: 0.9;
  padding: ${(props) => props.theme.size.dynamic0200};
  display: flex;
  gap: ${(props) => props.theme.size.dynamic0040};
  flex-direction: column;
  justify-content: center;
`;

const Header: React.FC<HeaderInterface> = ({title, descriptions, image}) => {
  return (
    <HeaderContainer>
      <ImageHeaderContainer>
        <img src={image.url} alt={image.alt} />
      </ImageHeaderContainer>
      <TitleHeaderContainer>
        <Text
          tag={TextTag.h1}
          appearance={TokenTextAppearance.headline500}
          bold
        >
          {title}
        </Text>
        {descriptions ? <Text>{descriptions}</Text> : null}
      </TitleHeaderContainer>
    </HeaderContainer>
  );
};

export default Header;
